import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "products-title"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "/", -1);
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "categories"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "product-list-container opacity-hide animateFadeInUp"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductList = _resolveComponent("ProductList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", null, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("products.title")) + " :", 1), _createElementVNode("a", {
    href: "javaScript:void(0)",
    class: _normalizeClass(["brand", {
      active: $data.productBrand == 'nyoni'
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.switchProductsBrand('nyoni'))
  }, _toDisplayString(_ctx.$t("products.nyoni")), 3), _hoisted_3, _createElementVNode("a", {
    href: "javaScript:void(0)",
    class: _normalizeClass(["brand", {
      active: $data.productBrand == 'feiyan'
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $options.switchProductsBrand('feiyan'))
  }, _toDisplayString(_ctx.$t("products.feiyan")), 3)]), $data.productBrand == 'nyoni' ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.$t("products.nyoinTitle")), 1)) : _createCommentVNode("", true), $data.productBrand == 'feiyan' ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.$t("products.feiyanTitle")), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [$data.productBrand == 'nyoni' ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [_createElementVNode("li", {
    onClick: _cache[2] || (_cache[2] = $event => $options.switchCategories('color_pencil'))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      active: _ctx.categoriesChoose == 'color_pencil'
    })
  }, _toDisplayString(_ctx.$t("common.productsCategory.color_pencil")), 3)]), _createElementVNode("li", {
    onClick: _cache[3] || (_cache[3] = $event => $options.switchCategories('sketch_pencil'))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      active: _ctx.categoriesChoose == 'sketch_pencil'
    })
  }, _toDisplayString(_ctx.$t("common.productsCategory.sketch_pencil")), 3)]), _createElementVNode("li", {
    onClick: _cache[4] || (_cache[4] = $event => $options.switchCategories('charcoal_pencil'))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      active: _ctx.categoriesChoose == 'charcoal_pencil'
    })
  }, _toDisplayString(_ctx.$t("common.productsCategory.charcoal_pencil")), 3)]), _createElementVNode("li", {
    onClick: _cache[5] || (_cache[5] = $event => $options.switchCategories('eraser'))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      active: _ctx.categoriesChoose == 'eraser'
    })
  }, _toDisplayString(_ctx.$t("common.productsCategory.eraser")), 3)]), _createElementVNode("li", {
    onClick: _cache[6] || (_cache[6] = $event => $options.switchCategories('other_tools'))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      active: _ctx.categoriesChoose == 'other_tools'
    })
  }, _toDisplayString(_ctx.$t("common.productsCategory.other_tools")), 3)])])) : _createCommentVNode("", true), $data.productBrand == 'feiyan' ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [_createElementVNode("li", {
    onClick: _cache[7] || (_cache[7] = $event => $options.switchCategories('color_pencil'))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      active: _ctx.categoriesChoose == 'color_pencil'
    })
  }, _toDisplayString(_ctx.$t("common.productsCategory.color_pencil")), 3)]), _createElementVNode("li", {
    onClick: _cache[8] || (_cache[8] = $event => $options.switchCategories('school_office_pencil'))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      active: _ctx.categoriesChoose == 'school_office_pencil'
    })
  }, _toDisplayString(_ctx.$t("common.productsCategory.school_office_pencil")), 3)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_ProductList, {
    products: $data.productsList
  }, null, 8, ["products"])])]);
}